import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';
import { TaskComponent } from '../../task/task.component';
import { Task } from '../../task';


@Component({
    selector: 'app-task-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.css'],
    standalone: false
})
export class PhoneComponent extends TaskComponent implements OnInit, AfterViewInit
{

	@Input() task: Task;

	ngOnInit()
	{
		// instantiate the baseClass
		this.taskApi = this.task;
		this.formTitle = 'Reach Out';
		super.ngOnInit();
	}
	ngAfterViewInit()
	{
		// assign the taskType to phone
		this.form1.patchValue({
			taskType: '2'
		});
	}
}
